export default __webpack_public_path__ + "static/media/dog.eafdb5a0.svg";